import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  Grid,
  TextField,
  Container,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { UrlApi } from "../../../services/apirest";
import { logEventos } from "../../../services/services";

const PuestosForm = ({
  isEditMode,
  rowInfo,
  handleOpenCloseModalForm,
  obtenerPuestos,
  mostrarAlertaTemporal,
}) => {
  const [data, setData] = useState({
    id: isEditMode ? rowInfo.id : undefined,
    puesto: isEditMode ? rowInfo.puesto : "",
    descripcion: isEditMode ? rowInfo.descripcion ?? "" : "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    logEventos(
      isEditMode ? "Editar puesto" : "Agregar puesto",
      "Puestos",
      isEditMode ? "Editar un puesto" : "Crear un puesto",
      localStorage.getItem("user")
    );

    let isValidForm = true;

    if (!data.puesto || data.puesto.trim() === "") {
      mostrarAlertaTemporal(
        "Por favor, complete todos los campos requeridos.",
        "error"
      );
      isValidForm = false;
    }

    if (isValidForm) {
      const newPuesto = {
        puesto: data.puesto,
        user: localStorage.getItem("user"),
        descripcion: data.descripcion,
        activa: 1,
      };

      const url = isEditMode
        ? `${UrlApi}/SP_puestos/${rowInfo.id}`
        : `${UrlApi}/SP_puestos`;
      const method = isEditMode ? "PUT" : "POST";

      try {
        const response = await fetch(url, {
          method,
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newPuesto),
        });

        const data = await response.json();

        if (response.ok) {
          mostrarAlertaTemporal(
            isEditMode
              ? "Actualización realizada correctamente"
              : "Puesto agregado con éxito",
            "success"
          );
          obtenerPuestos();
          handleOpenCloseModalForm();
        } else {
          mostrarAlertaTemporal(
            `Error al ${isEditMode ? "actualizar" : "agregar"} el puesto: ${
              data.message
            }`,
            "error"
          );
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
        mostrarAlertaTemporal("Hubo un problema con la solicitud.", "error");
      }

      handleOpenCloseModalForm();
    }
  };

  return (
    <Dialog
      open={true}
      onClose={handleOpenCloseModalForm}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="lg"
      fullWidth
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#1F618D",
          width: "100%",
          marginBottom: 4,
        }}
      >
        <DialogTitle>
          <Box component="div">
            <Typography
              variant="h6"
              align="center"
              color="#ffffff"
              sx={{ fontWeight: "bold" }}
            >
              {isEditMode ? "Editar puesto" : "Agregar nuevo puesto"}
            </Typography>
          </Box>
        </DialogTitle>
      </Box>
      <Container>
        <Grid container spacing={5}>
          <Grid item xs={12} sx={{ marginTop: 2 }}>
            <TextField
              fullWidth
              label="Puesto"
              required
              name="puesto"
              value={data.puesto}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              sx={{ overflow: "hidden" }}
              scro
              fullWidth
              label="Descripción"
              name="descripcion"
              value={data.descripcion}
              inputProps={{ maxLength: 85 }}
              helperText={`${data.descripcion?.length ?? 0}/85 caracteres`}
              onChange={handleChange}
              variant="outlined"
              multiline
              rows={3}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: 3,
            }}
          >
            <Button
              variant="contained"
              color="error"
              onClick={handleOpenCloseModalForm}
            >
              Volver
            </Button>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              {isEditMode ? "Guardar Cambios" : "Agregar puesto"}
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Dialog>
  );
};

export default PuestosForm;
